import { MarkdownToJSX } from "markdown-to-jsx";

export const MarkdownConfig: MarkdownToJSX.Overrides = {
  ul: {
    props: {
      className: "list-disc pl-4 mb-2",
    },
  },
  ol: {
    props: {
      className: "list-decimal pl-4 mb-2",
    },
  },
  h1: {
    props: {
      className: "font-bold mb-2",
    },
  },
  h2: {
    props: {
      className: "font-bold mb-2",
    },
  },
  h3: {
    props: {
      className: "font-bold mb-2",
    },
  },
  h4: {
    props: {
      className: "text-large-bold mb-4",
    },
  },
  p: {
    props: {
      className: "mb-2",
    },
  },
  code: {
    props: {
      className: "font-code",
    },
  },
  pre: {
    props: {
      className: "whitespace-pre-wrap",
    },
  },
};
